<template>
  <bl-card-mv
    style="width: 545px; cursor: pointer;"
    :class="{ 'product-card__selected': isSelected }"
    @click.native="onProductCardClick"
  >
    <div :style="decoration">
      <div
        style="position: absolute; width: 86px; height: 86px; padding: 6px; top: -20%; background: white; border-radius: 4px; box-shadow: 0px 1px 5px rgba(31, 31, 31, 0.15);"
      >
        <img
          :src="product.logo_url"
          :alt="`logo-${product.name}`"
          width="74px"
          height="74px"
          style="width: 74px; height: 74px;"
        />
      </div>

      <div style="margin-bottom: 26px">
        <bl-flex-container-mv align-items="center">
          <bl-flex-item-av :grow="1" :shrink="1" style="margin-right: 10px;">
            <bl-text-av
              class="product-card__product-return"
              align="right"
              style="font-size: 26px; line-height: 32px;"
              weight="bold"
              color="inverse"
            >
              {{ productReturn }}
            </bl-text-av>
          </bl-flex-item-av>
          <bl-flex-item-av>
            <bl-tooltip-mv is-multi-line :text="tooltipText">
              <ico-info color="#F7F7F7" />
            </bl-tooltip-mv>
          </bl-flex-item-av>
        </bl-flex-container-mv>
      </div>

      <bl-flex-container-mv align-items="center" style="margin-bottom: 10px;">
        <bl-flex-item-av class="mr-10" :col="8" :grow="1" :shrink="1">
          <bl-text-av class="product-card__product-name" :tag="productNameTag" :ellipsis="1" variation="body-16">
            {{ product.name }}
          </bl-text-av>
          <bl-text-av class="product-card__product-type" variation="body-14" color="subdued">
            {{ product.type }}
          </bl-text-av>
        </bl-flex-item-av>
        <bl-flex-item-av class="mr-10" :col="4" :grow="1" :shrink="1">
          <bl-text-av class="product-card__product-nav-date" variation="body-14" align="right">
            NAB/Unit ({{ navDate }})
          </bl-text-av>
          <bl-text-av class="product-card__product-nav-value" variation="subheading-18" weight="bold" align="right">
            {{ navValue | money }}
          </bl-text-av>
        </bl-flex-item-av>
      </bl-flex-container-mv>

      <bl-flex-container-mv v-if="isSelected" align-items="center">
        <bl-flex-item-av class="mr-10" :grow="1" :shrink="1">
          <bl-link-av
            :href="product.prospectus_url"
            rel="nofollow"
            target="_blank"
            is-contrast
            is-bold
            style="font-size: 14px"
          >
            Unduh Prospektus
          </bl-link-av>
        </bl-flex-item-av>
        <bl-flex-item-av class="mr-10" :grow="1" :shrink="1">
          <bl-link-av
            :href="product.factsheet_url"
            rel="nofollow"
            target="_blank"
            is-contrast
            is-bold
            style="font-size: 14px"
          >
            Unduh Keterangan Ringkas
          </bl-link-av>
        </bl-flex-item-av>
        <bl-flex-item-av basis="145px;" style="text-align: right;">
          <bl-button-av
            class="product-card__product-buy-button"
            variation="outline"
            size="small"
            @click="gotoLoginPage"
          >
            Beli produk
          </bl-button-av>
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </bl-card-mv>
</template>

<script>
import { assetURL } from 'shared/helpers/assetHelper';
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import BlCardMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlCardMv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexItemAv';
import BlButtonAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlButtonAv';
import BlTooltipMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTooltipMv';
import IcoInfo from '@bukalapak/bazaar-visual-next/dist/components/IcoInfo';
import BlLinkAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlLinkAv';
import formatDuration from 'shared/helpers/date/formatDuration';
import dayjs from 'dayjs';
import queryString from 'query-string';
import money from 'shared/helpers/number/money';

export default {
  name: 'ProductCard',
  filters: { money },
  components: {
    BlCardMv,
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlButtonAv,
    BlTooltipMv,
    IcoInfo,
    BlLinkAv,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    productNameTag: {
      type: String,
      default: 'h3',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    navDate() {
      if (this.product.last_nav_updated_at) {
        return dayjs(this.product.last_nav_updated_at).format('DD MMM YYYY');
      }
      return '';
    },

    navValue() {
      return Number(this.product.last_nav_value);
    },

    tooltipText() {
      return `Pertumbuhan nilai NAB pada ${this.returnDuration}`;
    },

    returnDuration() {
      const startDate = dayjs()
        .subtract(30, 'day')
        .toString();
      return formatDuration(startDate, dayjs().toString(), { month: 'MMMM' });
    },

    isSSR() {
      return this.$root.isSSR;
    },

    productReturn() {
      const productReturn = this.product.return_one_month;

      const sign = productReturn < 0 ? '' : '+';

      return `${sign}${productReturn}%`;
    },

    decoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'top center',
        'background-image': `url(${assetURL('product_card_decoration.png', this.isSSR)})`,
        'background-size': '100%',
        position: 'relative',
        padding: '16px 24px 24px 30px',
      };
    },
  },

  methods: {
    gotoLoginPage() {
      window.location.href = `/login?${queryString.stringify({
        comeback: this.$route.fullPath,
        direct: 1,
      })}`;
    },
    onProductCardClick() {
      this.$emit('click', this.product);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-card {
  &__selected {
    border: 2px solid #2dbfab;
    box-shadow: none;
  }
}
</style>
